import React from 'react';
import {
    MonetizationKpisSection,
    DetailedMetricsSection,
    DirectDepositAcquisitionSection,
} from './monetization';
import { applyDashboardDonutColors } from '../dashboard.constants';
import styles from './styles/monetization-data.module.scss';

// UI copy only (titles/subtitles). All numeric values come from the API.
const COPY = {
    feeIncome: { title: 'Fee Income', subtitle: 'Non-Interest Income' },
    directDeposit: { title: 'Direct Deposit', subtitle: 'Direct Deposit Switches' },
    advancesByType: { title: 'Advances by Type', subtitle: 'Instant vs. Standard', totalLabel: 'Advances' },
    avgUserMetrics: { title: 'Avg. User Metrics', subtitle: 'Advances & Advance size' },
    ddAcquisition: { title: 'DD Acquisition', subtitle: 'Enrolled users with vs. without DDS', totalLabel: 'Enrolled' },
    directDeposits: { title: 'Direct Deposits', subtitle: 'DDS county and volume inflows' },
};

function MonetizationData({ data, loading = false }) {
    const d = data || {};
    const usageKpis = d.usageKpis || [];
    const detailedKpis = d.detailedKpis || [];
    const feeIncome = { ...COPY.feeIncome, series: [], data: {}, ...(d.feeIncome || {}) };
    const directDeposit = { ...COPY.directDeposit, series: [], data: {}, ...(d.directDeposit || {}) };
    const advancesByType = { ...COPY.advancesByType, total: '0', segments: [], ...(d.advancesByType || {}) };
    advancesByType.segments = applyDashboardDonutColors(advancesByType.segments, 'advancesByType');
    const avgUserMetrics = { ...COPY.avgUserMetrics, series: [], data: {}, ...(d.avgUserMetrics || {}) };
    const ddAcquisition = { ...COPY.ddAcquisition, total: '0', segments: [], ...(d.ddAcquisition || {}) };
    ddAcquisition.segments = applyDashboardDonutColors(ddAcquisition.segments, 'ddAcquisition');
    const directDeposits = { ...COPY.directDeposits, series: [], data: {}, ...(d.directDeposits || {}) };

    return (
        <div className={styles.monetizationContainer}>
            <MonetizationKpisSection
                kpis={usageKpis}
                feeIncome={feeIncome}
                directDeposit={directDeposit}
                loading={loading}
            />
            <DetailedMetricsSection
                kpis={detailedKpis}
                advancesByType={advancesByType}
                avgUserMetrics={avgUserMetrics}
                loading={loading}
            />
            <DirectDepositAcquisitionSection
                ddAcquisition={ddAcquisition}
                directDeposits={directDeposits}
                loading={loading}
            />
        </div>
    );
}

export default MonetizationData;
